<template>
  <div v-bind:class="{
    'loader-container': true,
    'small': size === 'small',
    'large': size === 'large'
  }">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  props: [ 'size' ]
}
</script>

<style scoped>
.loader {
  border: 8px solid #222;
  border-top: 8px solid #4A838C;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  width: 100%;
  height: 100%;
}

.small {
  width: 1rem;
  height: 1rem;
  display: inline-block;
  transform: translateY(-100%);
}

.large {
  width: 30px;
  height: 30px;
}

.large .loader {
  margin: 3rem auto;
}

.loader-container {
  opacity: 0;
  animation: fadein ease-in 1s forwards;
  margin: 0 auto;
}

@keyframes fadein {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// Loader.vue?960e9cb8